import {
  AlertTriangle,
  CheckCircle2,
  ClipboardList,
  Clock,
} from 'lucide-react';
import React from 'react';

import { KdsKpis } from '@/renderer/types/kds';

interface KdsKpiBarProps {
  kpis: KdsKpis;
}

/**
 * Slim inline stat group (icon + label + value) — rendered as part of
 * KitchenDisplayPage's combined department-picker row, not its own bar, so
 * it returns a fragment rather than owning any outer wrapper/border.
 */
export const KdsKpiBar: React.FC<KdsKpiBarProps> = ({ kpis }) => {
  const stats: {
    icon: typeof ClipboardList;
    label: string;
    value: string | number;
    isAlert?: boolean;
  }[] = [
    {
      icon: ClipboardList,
      label: 'Active Orders',
      value: kpis.active_orders,
    },
    {
      icon: Clock,
      label: 'Avg. Time',
      value: `${kpis.average_time_minutes} mins`,
    },
    {
      icon: CheckCircle2,
      label: 'Completed',
      value: kpis.completed_orders,
    },
    {
      icon: AlertTriangle,
      label: 'Delayed',
      value: kpis.delayed_orders,
      isAlert: kpis.delayed_orders > 0,
    },
  ];

  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
      {stats.map(({ icon: Icon, label, value, isAlert }, index) => (
        <div
          key={label}
          className={`flex items-center gap-2 text-base ${
            index > 0 ? 'border-l border-gray-200 pl-6' : ''
          }`}
        >
          <Icon
            size={18}
            className={isAlert ? 'text-red-500' : 'text-gray-500'}
          />
          <span className="text-gray-600">{label}</span>
          <span
            className={`font-bold ${isAlert ? 'text-red-600' : 'text-black'}`}
          >
            {value}
          </span>
        </div>
      ))}
    </div>
  );
};
